import { Component } from '@angular/core';
import { HttpErrorResponse } from "@angular/common/http";
import { Router } from "@angular/router";
import { AuthService, Credentials, UserModel, UserService, CourseService } from "@bt/core";
import { TokenError } from "./login.interfaces";
import { Validators, EmailValidator, FormBuilder, FormGroup, FormControl } from '@angular/forms';
import { environment } from "@src/environments/environment";
import { NotifierService } from 'angular-notifier';
import {faCheckCircle,faTimesCircle} from "@fortawesome/free-solid-svg-icons"
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { far } from '@fortawesome/free-regular-svg-icons';
import { BaseComponent } from "@bt/core/base";


library.add(fas, far);
library.add(faCheckCircle);
library.add(faTimesCircle);

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.scss"]
})
export class LoginComponent extends BaseComponent {
  private notifier: NotifierService;
  public error: TokenError;
  public showLoader: boolean = false;
  textError: string;

  protected logoFileName: string = environment.logoFileName;
  protected logoHeader: string = environment.logoHeader || "Custody project";

  // private emailPattern = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  public loginForm: FormGroup;
  public isSubmitted: boolean = false;
  public emailModel : any;
  public passwordModel : any;
  public online: boolean = navigator.onLine;

  constructor(private authService: AuthService,
     private router: Router,
     private fb: FormBuilder,
     notifierService: NotifierService,
     private userService: UserService,
     private courseService: CourseService,
     ) {
    super();
    this.textError = "";
    this.notifier = notifierService;

    var t=this;
    // if(this.authService.authData!=undefined){
    //   this.courseService
    //   .getUser()
    //   .then(
    //     (response) => {

    //       if (response.data.role == 1 || response.data.role == 0) {
    //         this.router.navigateByUrl("profile")
    //           .then(() => this.showLoader = false);
    //       }
    //       else if (response.data.role == 2) {
    //         this.router.navigateByUrl("all-users")
    //           .then(() => this.showLoader = false);
    //       }
    //       t.setLoading(false);

    //     },
    //   )
    //   .catch((error) => {
    //     console.error(error.error);
    //     this.authService.logout();
    //     t.setLoading(false);

    //   });
    // }
  }

  public login() {
    var t = this;
    this.isSubmitted = true;



    if (!this.loginForm.valid){
      this.notifier.notify("error", "Проверьте корректность введённых данных");
      this.showLoader = false;
      return;
    }


    const credentials: Credentials = this.loginForm.value;
    if (!this.showLoader) {
      this.showLoader = true;
      t.setLoading(true);
      this.authService
        .login(credentials)
        .subscribe(
          (response) => {
            this.courseService
              .getUser()
              .then(
                (response) => {

                  this.router.navigateByUrl("balances")
                      .then(() => this.showLoader = false);
                  t.setLoading(false);

                },
              )
              .catch((error) => {
                console.error(error.error);
                this.authService.logout();
                t.setLoading(false);

              });

          },
          (error: HttpErrorResponse) => {
            t.error = error.error;


            if (t.error != undefined && t.error.error_description != undefined) {

              t.textError = t.error.error_description;
              if (t.textError == "Invalid username or password")
              this.notifier.notify("error", "Неправильный логин или пароль");
            }

            console.log("Error:" + t.error.error_description);
            this.showLoader = false;
            t.setLoading(false);

          }
        );
    }
  }

  public clearError() {
    this.error = null;
  }

  public ngOnInit() {
    this.loginForm = this.fb.group({
      email: ["", [Validators.required]],//Validators.pattern(this.emailPattern)
      password: new FormControl(null, Validators.required),
    });

    this.loginForm.valueChanges
      .filter(() => !!this.error)
      .forEach(() => {
        this.clearError();
      });
  }

  // public alwaysChecked(){
  //   this.checkbox.setValue(true);
  // }
  get email() { return this.loginForm.get('email'); }
  get password() { return this.loginForm.get('password'); }

}



// WEBPACK FOOTER //
// ./src/app/public/login/login.component.ts